import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

/**
 *  Gets the fallback value for show week numbers
 */
export default () =>
    getFallbackValueIfNull(store().showWeekNumbers, getCalendarConfiguration().ShowWeekNumbers);
